module.exports = "./img/64225b2778fbab66e7e3bfa12e0e1bc5.jpg";